import React from 'react'

import { Typography } from '@material-ui/core'

const Installed = ({ classes }) =>
  <div className={classes.Equipment_Infos} >
    <Typography align='center' variant='body1' component='h5'>
      {I18n.t('v4/equipment.dashboard.info_data')}
    </Typography>

    <Typography align='center' component='h5'>
      {I18n.t('v4/equipment.dashboard.info_equipment')}
    </Typography>
  </div>

export default Installed
